export enum ReportTemplateRecordTypeEnum {
  ADD_SECTION = "ADD_SECTION",
  REMOVE_SECTION = "REMOVE_SECTION",
  UPDATE_SECTION = "UPDATE_SECTION",
}

export const getReportTemplateRecordLabel = (type: ReportTemplateRecordTypeEnum, entity: string): string => {
  switch (type) {
    case ReportTemplateRecordTypeEnum.ADD_SECTION:
      return `Agregó una sección a la ${entity}`;
    case ReportTemplateRecordTypeEnum.REMOVE_SECTION:
      return `Borró una sección de la ${entity}`;
    case ReportTemplateRecordTypeEnum.UPDATE_SECTION:
      return `Actualizó una sección de la ${entity}`;
  }
};
